import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

const OrderDetails = ({ ToggleOpen, open, data }) => {
  return (
    <>
      <Dialog
        open={open}
        keepMounted
        onClose={() => ToggleOpen()}
        aria-describedby="alert-dialog-slide-description"
        maxWidth={"md"}
        fullWidth={true}
      >
        <DialogTitle>{"Order Details"} </DialogTitle>

        <DialogContent>
          {data && data.length > 0 ? (
            data.map((event, index) => (
              <div key={index} className="shadow-sm p-1 mb-1 bg-body card">
                <div className="d-flex flex-wrap ">
                  {open && (
                    <img
                      src="https://cdn.shopify.com/s/files/1/0578/1228/7660/files/VWT23-A_6.jpg?v=1727774698"
                      alt="Product Image"
                      style={{ width: 50, height: 50 }}
                    />
                  )}
                  &nbsp;
                  <button className="magic-button magic-button-green m-2">
                    <b>{event.quantity}</b>
                  </button>
                  &nbsp;
                  <span className="btn btn-sm">{event.name}</span>
                  {/* <p>Store: {event.store_id}</p> */}
                </div>
              </div>
            ))
          ) : (
            <p>No order details available</p>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => ToggleOpen()}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default OrderDetails;
